export default __webpack_public_path__ + "static/meltyring-8c2c3143290c4fc9aea73da243be8dee.png";